export const ADD_COMPANY_INFO = "ADD_COMPANY_INFO";
export const ADD_DPO_INFO = "ADD_DPO_INFO";
export const ADD_PLANS = "ADD_PLANS";
export const ADD_AREAS = "ADD_AREAS";